<template>
  <div class="amap-page-container">
    <div class="map_container_wrap">
      <div style="position:relative;height:400px;">
        <div class="search-box">
          <input id="search" v-model="searchKey" type="search" />
          <button @click="searchByHand">
            搜索
          </button>
          <div id="searchTip" class="tip-box" />
        </div>
        <el-amap
          v-if="showMap"
          vid="amap"
          :plugin="plugin"
          :center="center"
          :zoom="zoom"
          :events="events"
          :amap-manager="amapManager"
        >
          <el-amap-marker
            :position="marker.position"
            draggable="false"
            clickable="false"
            bubble="true"
            :events="marker.events"
          />
          <!-- 信息窗口 -->
          <el-amap-info-window
            :position="currentWindow.position"
            :visible="currentWindow.visible"
            :events="currentWindow.events"
            :offset="currentWindow.offset"
            :class="amap - info - close"
          >
            <div :style="slotStyle" class="windowStyle">
              <strong>名称：</strong>
              {{ name }}
              <br />
              <strong>地址：</strong>
              {{ address }}
              <br />
              <strong>经度</strong>
              &nbsp;&nbsp;&nbsp;{{ lng }}
              <br />
              <strong>纬度</strong>
              &nbsp;&nbsp;&nbsp;{{ lat }}
              <!-- <br/>
            <button @click="confirm">确定</button>&nbsp;&nbsp;&nbsp;
            <button @click="cancle">取消</button> -->
            </div>
          </el-amap-info-window>
        </el-amap>
      </div>
      <div class="form-container">
        <el-form
          ref="formInfo"
          :model="formInfo"
          :rules="rules"
          label-width="120px"
          class="edit-form"
        >
          <!-- 地址类型选择 -->
          <div class="address-type-selector" v-if="false">
            <div class="selector-title">
              地图地址选择类型
            </div>
            <el-radio-group
              v-model="selectedAddressType"
              class="address-radio-group"
              @change="onAddressTypeChange"
            >
              <el-radio
                v-if="editType !== 'onlyUpload'"
                label="shipper"
                class="address-radio"
              >
                <i class="el-icon-upload2" />
                装货地址
              </el-radio>
              <el-radio label="consignee" class="address-radio">
                <i class="el-icon-download" />
                卸货地址
              </el-radio>
            </el-radio-group>
          </div>
          <!-- 装货信息 -->
          <div
            v-if="
              editType !== 'onlyUpload' && selectedAddressType === 'shipper'
            "
            class="form-section"
            :class="{ highlighted: selectedAddressType === 'shipper' }"
          >
            <div
              class="section-title"
              style="display: flex; justify-content: space-between;"
            >
              <div><i class="el-icon-upload2" /> 装货信息</div>
              <div>原装货地址:&ensp;&ensp;{{ oldShipperAddress }}</div>
            </div>
            <div class="section-content">
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="装货地址" prop="shipperTotalAddress">
                    <el-input
                      v-model="formInfo.shipperTotalAddress"
                      placeholder="请输入装货地址"
                      clearable
                      :disabled="true"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="装货经度" prop="shipperLongitude">
                    <el-input
                      v-model="formInfo.shipperLongitude"
                      placeholder="请输入装货经度"
                      clearable
                      :disabled="true"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="装货纬度" prop="shipperLatitude">
                    <el-input
                      v-model="formInfo.shipperLatitude"
                      placeholder="请输入装货纬度"
                      clearable
                      :disabled="true"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 卸货信息 -->
          <div
            v-if="selectedAddressType === 'consignee'"
            class="form-section"
            :class="{ highlighted: selectedAddressType === 'consignee' }"
          >
            <div
              class="section-title"
              style="display: flex; justify-content: space-between;"
            >
              <div>
                <i class="el-icon-download" />
                卸货信息
              </div>
              <div>原卸货地址:&ensp;&ensp;{{ oldConsigneeAddress }}</div>
            </div>
            <div class="section-content">
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="卸货地址" prop="consigneeTotalAddress">
                    <el-input
                      v-model="formInfo.consigneeTotalAddress"
                      placeholder="请输入卸货地址"
                      clearable
                      :disabled="true"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="卸货经度" prop="consigneeLongitude">
                    <el-input
                      v-model="formInfo.consigneeLongitude"
                      placeholder="请输入卸货经度"
                      clearable
                      :disabled="true"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="卸货纬度" prop="consigneeLatitude">
                    <el-input
                      v-model="formInfo.consigneeLatitude"
                      placeholder="请输入卸货纬度"
                      clearable
                      :disabled="true"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- 联系人信息 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-user" />
              联系人信息
            </div>
            <div class="section-content">
              <!-- 发货联系人信息 -->
              <div class="subsection-title">发货联系人信息</div>
              <el-row :gutter="24">
                <el-col :span="12">
                  <!-- :disabled="selectedAddressType === 'consignee'" -->
                  <el-form-item label="发货联系人姓名" prop="shipperName">
                    <el-input
                      v-model="formInfo.shipperName"
                      placeholder="请输入发货联系人姓名"
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <!-- :disabled="selectedAddressType === 'consignee'" -->
                  <el-form-item label="发货联系电话" prop="shipperPhone">
                    <el-input
                      v-model="formInfo.shipperPhone"
                      placeholder="请输入发货联系电话"
                      clearable
                      max-length="20"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 卸货联系人信息 -->
              <div class="subsection-title">卸货联系人信息</div>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="卸货联系人姓名" prop="consigneeName">
                    <el-input
                      v-model="formInfo.consigneeName"
                      placeholder="请输入卸货联系人姓名"
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="卸货联系电话" prop="consigneePhone">
                    <el-input
                      v-model="formInfo.consigneePhone"
                      placeholder="请输入卸货联系电话"
                      clearable
                      max-length="20"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
    </div>

    <!-- 确定按钮 -->
    <div class="btn_container">
      <el-button type="primary" @click="submitForm">确定修改</el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// 引入vue-amap
import VueAMap from "vue-amap";
Vue.use(VueAMap);
let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
let AMapKey = "";
if (dataBranch) {
  if (dataBranch.partyGroupConfigCacheMap.amapKey_webJs) {
    AMapKey = dataBranch.partyGroupConfigCacheMap.amapKey_webJs.configValue;
  }
  if (dataBranch.partyGroupConfigCacheMap.amapKey_webJs_security) {
    window._AMapSecurityConfig = {
      securityJsCode:
        dataBranch.partyGroupConfigCacheMap.amapKey_webJs_security.configValue
    };
  }
}
VueAMap.initAMapApiLoader({
  key: AMapKey,
  // 插件集合
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.Geocoder",
    "AMap.Geolocation"
  ],
  // 高德 sdk 版本，默认为 1.4.4
  v: "1.4.4",
  uiVersion: "1.0"
});
import { AMapManager, lazyAMapApiLoaderInstance } from "vue-amap";
const amapManager = new AMapManager();
import { updateAddrByCode } from "@/api/shipment";
export default {
  name: "MapSelect",
  props: {
    positionInfo: {
      type: Object,
      default: () => {}
    },
    // 修改类型
    editType: {
      type: String,
      default: ""
    }
  },
  data() {
    let self = this;
    return {
      formInfo: {},
      selectedAddressType: "consignee", // 默认选择装货地址
      // 表单验证规则
      rules: {
        shipperName: [
          { required: true, message: "请输入发货联系人姓名", trigger: "blur" }
        ],
        shipperPhone: [
          { required: true, message: "请输入发货联系电话", trigger: "blur" },
          {
            pattern: /^(1[3-9]\d{9})|(0\d{2,3}[- ]?\d{7,8})|(\d{7,8})$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        consigneeName: [
          { required: true, message: "请输入卸货联系人姓名", trigger: "blur" }
        ],
        consigneePhone: [
          { required: true, message: "请输入卸货联系电话", trigger: "blur" },
          {
            pattern: /^(1[3-9]\d{9})|(0\d{2,3}[- ]?\d{7,8})|(\d{7,8})$/,
            message: "请输入正确的手机号或固定电话",
            trigger: "blur"
          }
        ]
      },
      showMap: false,
      searchKey: "",
      zoom: 12,
      center: [118.311371, 35.140127],
      address: "",
      name: "",
      lng: 121.630925,
      lat: 29.866002,
      loaded: false,
      currentLocation: "",
      plugin: [
        {
          // 定位
          pName: "Geolocation",
          events: {
            init(o) {
              // o是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {
                  // 设置经度
                  self.lng = result.position.lng;
                  // 设置维度
                  self.lat = result.position.lat;
                  // 设置坐标
                  self.center = [self.lng, self.lat];
                  self.address = result.formattedAddress;
                  self.adcode = result.addressComponent.adcode;
                  let district = result.addressComponent.district;
                  let address = result.formattedAddress;
                  if (result.formattedAddress.indexOf(district) > -1) {
                    address = result.formattedAddress.substring(
                      result.formattedAddress.indexOf(district) +
                        district.length,
                      result.formattedAddress.length
                    );
                  }
                  self.name = address;
                  self.currentLocation = {
                    center: self.center,
                    address: self.address,
                    name: self.name,
                    adcode: self.adcode,
                    lng: self.lng,
                    lat: self.lat
                  };
                  // load
                  self.loaded = true;
                  // 页面渲染好后
                  self.$nextTick();
                }
              });
            }
          }
        }
      ],
      searchOption: {
        city: "全国",
        citylimit: true
      },
      shipmentUserCode: "",
      amapManager: amapManager,
      driverName: "",
      driverCode: "",
      marker: {
        position: [118.311371, 35.140127],
        events: {
          dragstart: e => {
            this.currentWindow.visible = false;
          },
          dragend: e => {
            this.marker.position = [e.lnglat.lng, e.lnglat.lat];
            this.currentWindow.visible = true;
            this.currentWindow.position = [e.lnglat.lng, e.lnglat.lat];
          }
        },
        visible: true
      },
      windows: [],
      window: "",
      events: {
        init() {
          lazyAMapApiLoaderInstance.load().then(() => {
            self.initSearch();
          });
        },
        click(e) {
          //添加标记点
          self.addMarker(e);
        }
      },
      currentWindow: {
        position: [118.311371, 35.140127],
        offset: [0, -28],
        events: {
          close() {}
        },
        visible: false
      },
      slotStyle: {
        padding: "2px 8px",
        color: "#333"
      },
      loading: {},
      delivery: {},
      adcode: "",
      infoWindow: "",
      oldShipperAddress: "",
      oldConsigneeAddress: ""
    };
  },
  watch: {
    positionInfo: {
      handler(newVal, oldVal) {
        if (newVal) {
          // this.initShow(newVal);
          console.log("传输的值=====", newVal);
          this.formInfo = JSON.parse(JSON.stringify(newVal));
          this.formInfo.shipperTotalAddress =
            this.formInfo.shipperAddress + this.formInfo.shipperDetailAddress;
          this.formInfo.consigneeTotalAddress =
            this.formInfo.consigneeAddress +
            this.formInfo.consigneeDetailAddress;
          this.oldShipperAddress = this.formInfo.shipperTotalAddress;
          this.oldConsigneeAddress = this.formInfo.consigneeTotalAddress;
          let tab;
          if (this.editType !== "onlyUpload") {
            tab = {
              location:
                this.formInfo.shipperLongitude +
                "," +
                this.formInfo.shipperLatitude,
              adcode: this.formInfo.shipperSubdivisionCode,
              pname: this.formInfo.shipperProvice,
              cityname: this.formInfo.shipperCity,
              adname: this.formInfo.shipperArea,
              address: this.formInfo.shipperDetailAddress
            };
            console.log("tab装货==========", tab);
          } else {
            tab = {
              location:
                this.formInfo.consigneeLongitude +
                "," +
                this.formInfo.consigneeLatitude,
              adcode: this.formInfo.consigneeSubdivisionCode,
              pname: this.formInfo.consigneeProvice,
              cityname: this.formInfo.consigneeCity,
              adname: this.formInfo.consigneeArea,
              address: this.formInfo.consigneeDetailAddress
            };
            console.log("ta卸货==========", tab);
          }
          this.initShow(tab);
        }
      },
      deep: true,
      immediate: true
    },
    editType: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.selectedAddressType =
            newVal === "onlyUpload" ? "consignee" : "shipper";
        }
      },
      immediate: true
    }
  },
  created() {
    this.currentWindow.visible = false;
  },
  mounted() {
    this.showMap = true;
  },
  methods: {
    submitForm() {
      this.$refs["formInfo"].validate(valid => {
        if (valid) {
          this.formInfo.orderCode = this.formInfo.code;
          // 加入二次提示
          this.$confirm("确认修改运输信息吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            updateAddrByCode(this.formInfo).then(res => {
              if (res.status == 0) {
                this.$emit("updateList");
                this.$message({
                  message: "更新成功",
                  type: "success"
                });
              }
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    amap() {},
    info() {},
    close() {},
    confirm() {
      this.currentWindow.visible = false;
      this.$emit(
        "fatherMethod",
        this.address,
        this.name,
        this.center,
        this.adcode
      );
      this.currentWindow.events.close();
    },
    cancle() {
      this.currentWindow.visible = false;
    },
    //搜索下拉选点击事件
    onSearchResult(pois) {
      //添加标记点
      this.addMarker({ lnglat: pois[0].location });
    },
    switchWindow() {
      const site = [this.lng, this.lat];
      this.center = site;
      this.zoom = 14;
      this.marker.position = site;
      this.currentWindow.position = site;
      this.currentWindow.visible = true;
    },
    initShow(tab) {
      this.currentWindow.visible = false;
      if (tab) {
        var tabData = tab;
        var siteArr = [];
        siteArr = tabData.location.split(",");
        this.center = siteArr;
        this.zoom = 14;
        this.adcode = tab.adcode;
        this.marker.position = siteArr;
        this.currentWindow.position = siteArr;
        this.address =
          tabData.pname + tabData.cityname + tabData.adname + tabData.address;
        this.name = tab.name;
        this.lng = siteArr[0];
        this.lat = siteArr[1];
        this.currentWindow.visible = true;
      } else if (this.currentLocation) {
        this.center = this.currentLocation.center;
        this.zoom = 14;
        this.adcode = this.currentLocation.adcode;
        this.marker.position = this.currentLocation.center;
        this.currentWindow.position = this.currentLocation.center;
        this.address = this.currentLocation.address;
        this.name = this.currentLocation.name;
        this.lng = this.currentLocation.lng;
        this.lat = this.currentLocation.lat;
        this.currentWindow.visible = true;
      }
    },
    //添加标记点
    addMarker(e) {
      let self = this;
      let { lng, lat } = e.lnglat;
      self.lng = lng;
      self.lat = lat;
      // 这里通过高德 SDK 完成。
      var geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: "all",
        homeorcorp: 2
      });
      geocoder.getAddress([lng, lat], (status, result) => {
        if (status === "complete" && result.info === "OK") {
          console.log("result=====???????", result, this.selectedAddressType);
          if (result && result.regeocode) {
            if (this.selectedAddressType === "shipper") {
              this.formInfo.shipperAddress =
                result.regeocode.addressComponent.province +
                result.regeocode.addressComponent.city +
                result.regeocode.addressComponent.district;

              this.formInfo.shipperArea =
                result.regeocode.addressComponent.district;

              this.formInfo.shipperCity =
                result.regeocode.addressComponent.city;
              let crosses = "";
              if (
                result.regeocode.crosses &&
                result.regeocode.crosses.length > 0
              ) {
                crosses = result.regeocode.crosses[0].first_name;
              }
              let aois = "";
              if (result.regeocode.aois && result.regeocode.aois.length > 0) {
                aois = result.regeocode.aois[0].name;
              }
              this.formInfo.shipperDetailAddress = result.regeocode.formattedAddress.replace(
                this.formInfo.shipperAddress,
                ""
              );
              // result.regeocode.addressComponent.township + crosses + aois;
              this.formInfo.shipperTotalAddress =
                this.formInfo.shipperAddress +
                this.formInfo.shipperDetailAddress;
              this.formInfo.shipperLatitude = lat;
              this.formInfo.shipperLongitude = lng;
              this.formInfo.shipperProvice =
                result.regeocode.addressComponent.province;

              this.formInfo.shipperSubdivisionCode =
                result.regeocode.addressComponent.adcode;
              this.name = result.regeocode.pois[0].name;
              this.address = result.regeocode.formattedAddress;
              console.log("装货form信息==========", this.formInfo);
            } else {
              this.formInfo.consigneeAddress =
                result.regeocode.addressComponent.province +
                result.regeocode.addressComponent.city +
                result.regeocode.addressComponent.district;

              this.formInfo.consigneeArea =
                result.regeocode.addressComponent.district;

              this.formInfo.consigneeCity =
                result.regeocode.addressComponent.city;
              console.log(
                " this.formInfo.consigneeArea ======",
                this.formInfo.consigneeArea,
                this.formInfo.consigneeCity
              );
              let crosses = "";
              if (
                result.regeocode.crosses &&
                result.regeocode.crosses.length > 0
              ) {
                crosses = result.regeocode.crosses[0].first_name;
              }
              let aois = "";
              if (result.regeocode.aois && result.regeocode.aois.length > 0) {
                aois = result.regeocode.aois[0].name;
              }
              this.formInfo.consigneeDetailAddress = result.regeocode.formattedAddress.replace(
                this.formInfo.consigneeAddress,
                ""
              );
              // result.regeocode.addressComponent.township + crosses + aois;
              this.formInfo.consigneeTotalAddress =
                this.formInfo.consigneeAddress +
                this.formInfo.consigneeDetailAddress;
              this.formInfo.consigneeLatitude = lat;
              this.formInfo.consigneeLongitude = lng;
              this.formInfo.consigneeProvice =
                result.regeocode.addressComponent.province;

              this.formInfo.consigneeSubdivisionCode =
                result.regeocode.addressComponent.adcode;
              this.name = result.regeocode.pois[0].name;
              this.address = result.regeocode.formattedAddress;
              console.log("装货form信息==========", this.formInfo);
            }
            // self.adcode = result.regeocode.addressComponent.adcode;
            // self.address = result.regeocode.formattedAddress;
            // self.name = result.regeocode.pois[0].name;
            self.switchWindow();
            self.$nextTick();
          }
        }
      });
    },
    initSearch() {
      let vm = this;
      let map = this.amapManager.getMap();
      AMapUI.loadUI(["misc/PoiPicker"], function(PoiPicker) {
        var poiPicker = new PoiPicker({
          // city: '371300',
          // citylimit: true,
          input: "search",
          placeSearchOptions: {
            map: map,
            pageSize: 10
          },
          suggestContainer: "searchTip",
          searchResultsContainer: "searchTip"
        });
        vm.poiPicker = poiPicker;
        // 监听poi选中信息
        poiPicker.on("poiPicked", function(poiResult) {
          console.log("监听poi选中信息=========", poiResult);
          let source = poiResult.source;
          let poi = poiResult.item;
          if (source !== "search") {
            poiPicker.searchByKeyword(poi.name);
          } else {
            poiPicker.clearSearchResults();
            let lng = poi.location.lng;
            let lat = poi.location.lat;
            let address = poi.pname + poi.cityname + poi.adname + poi.address;
            vm.currentWindow.visible = false;
            vm.lng = lng;
            vm.lat = lat;
            vm.address = address;
            vm.searchKey = "";
            vm.adcode = poi.adcode;
            vm.name = poi.name;
            vm.center = [lng, lat];
            // vm.switchWindow()
            vm.newInfoWindow();
            vm.addMarker({ lnglat: poi.location });
          }
        });
      });
    },
    searchByHand() {
      if (this.searchKey !== "") {
        this.poiPicker.searchByKeyword(this.searchKey);
      }
    },
    newInfoWindow() {
      let infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -20)
      });
      infoWindow.setMap(this.amapManager.getMap());
      infoWindow.setPosition(this.center);
      infoWindow.open(this.amapManager.getMap(), this.center);
      infoWindow.setContent(`
          <div :style="slotStyle" class="windowStyle">
          <strong>名称：</strong>
          ${this.name}
          <br />
          <strong>地址：</strong>
          ${this.address}
          <br />
          <strong>经度</strong>
          &nbsp;&nbsp;&nbsp;${this.lng}
          <br />
          <strong>纬度</strong>
          &nbsp;&nbsp;&nbsp;${this.lat}
        </div>
            `);
      this.infoWindow = infoWindow;
    },
    // 地址类型选择变化处理方法
    onAddressTypeChange(value) {
      console.log("地址类型选择变化:", value);
      // 可以在这里添加其他逻辑，比如更新地图中心点等
      if (
        value === "shipper" &&
        this.formInfo.shipperLongitude &&
        this.formInfo.shipperLatitude
      ) {
        // 如果选择装货地址且有装货坐标，则将地图中心移动到装货位置
        this.center = [
          parseFloat(this.formInfo.shipperLongitude),
          parseFloat(this.formInfo.shipperLatitude)
        ];
        this.marker.position = this.center;
      } else if (
        value === "consignee" &&
        this.formInfo.consigneeLongitude &&
        this.formInfo.consigneeLatitude
      ) {
        // 如果选择卸货地址且有卸货坐标，则将地图中心移动到卸货位置
        this.center = [
          parseFloat(this.formInfo.consigneeLongitude),
          parseFloat(this.formInfo.consigneeLatitude)
        ];
        this.marker.position = this.center;
      }
    }
  }
};
</script>
<style>
.amap-info-close {
  position: absolute;
  top: 5px;
  color: #c3c3c3;
  text-decoration: none;
  width: 14px;
  height: 14px;
  display: none;
}
</style>
<style scoped>
.btn_container {
  margin-top: 15px;
  text-align: right;
  margin-right: 20px;

  /* 上阴影 */
}
.map_container_wrap {
  /* height: 680px;
  overflow: auto; */
  height: calc(100% - 60px);
  overflow: auto;
  border-bottom: 1px solid #e3e6eb;
}

.amap-orderMana {
  height: 400px;
}

.amap-page-container {
  position: relative;
  height: 100%;
  background: #f5f7fa;
}

.search-box {
  position: absolute;
  z-index: 5;
  width: 70%;
  left: 13%;
  top: 10px;
  height: 30px;
}

.search-box input {
  float: left;
  width: 80%;
  height: 100%;
  border: 1px solid #2882fe;
  padding: 0 8px;
  outline: none;
  border-radius: 4px 0 0 4px;
  font-size: 14px;
}

.search-box button {
  float: left;
  width: 20%;
  height: 100%;
  background: #2882fe;
  border: 1px solid #2882fe;
  color: #fff;
  outline: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.search-box button:hover {
  background: #1f6fd1;
}

.tip-box {
  width: 100%;
  max-height: 260px;
  position: absolute;
  top: 30px;
  overflow-y: auto;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 表单容器样式 */
.form-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: 40%;
  overflow-y: auto;
}

.edit-form {
  max-width: 1200px;
  margin: 0 auto;
}

/* 表单分组样式 */
.form-section {
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e4e7ed;
  overflow: hidden;
  transition: all 0.3s ease;
}

.form-section:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

/* 高亮样式 */
.form-section.highlighted {
  border: 2px solid #409eff;
  box-shadow: 0 4px 20px rgba(64, 158, 255, 0.2);
  transform: translateY(-2px);
}

.form-section.highlighted .section-title {
  background: linear-gradient(135deg, #409eff, #63acf4);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

/* 地址类型选择器样式 */
.address-type-selector {
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e4e7ed;
  overflow: hidden;
}

.selector-title {
  background: #f8f9fa;
  color: #606266;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e4e7ed;
}

.selector-title i {
  margin-right: 8px;
  font-size: 16px;
  color: #409eff;
}

.address-radio-group {
  padding: 16px 20px;
  display: flex;
  gap: 24px;
}

.address-radio {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

.address-radio i {
  margin-right: 6px;
  font-size: 16px;
}

.address-radio .el-radio__label {
  display: flex;
  align-items: center;
  color: #606266;
  font-weight: 500;
}

.address-radio.is-checked .el-radio__label {
  color: #409eff;
}

.address-radio.is-checked i {
  color: #409eff;
}

.section-title {
  background: #63acf4;
  color: #ffffff;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e4e7ed;
}

.section-title i {
  margin-right: 8px;
  font-size: 18px;
}

.section-content {
  padding: 24px 20px 16px;
}

.subsection-title {
  color: #606266;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
  padding-left: 12px;
  border-left: 3px solid #409eff;
  background: #f8f9fa;
  padding: 8px 12px;
  border-radius: 4px;
}

/* 表单项样式优化 */
.edit-form .el-form-item {
  margin-bottom: 20px;
}

.edit-form .el-form-item__label {
  color: #606266;
  font-weight: 500;
  line-height: 1.5;
}

.edit-form .el-input__inner {
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s ease;
  font-size: 14px;
  padding: 0 15px;
  height: 40px;
}

.edit-form .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.edit-form .el-input__inner:hover {
  border-color: #c0c4cc;
}

.edit-form .el-input__inner::placeholder {
  color: #c0c4cc;
  font-size: 13px;
}

/* 清除按钮样式 */
.edit-form .el-input__suffix {
  right: 10px;
}

.edit-form .el-input__clear {
  color: #c0c4cc;
  transition: color 0.3s ease;
}

.edit-form .el-input__clear:hover {
  color: #909399;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .form-container {
    padding: 10px;
  }

  .section-content {
    padding: 16px 12px 8px;
  }

  .edit-form .el-col {
    margin-bottom: 10px;
  }

  .section-title {
    padding: 12px 16px;
    font-size: 14px;
  }

  .subsection-title {
    font-size: 13px;
    margin-bottom: 12px;
  }
}

@media (max-width: 480px) {
  .edit-form {
    margin: 0;
  }

  .edit-form .el-form-item__label {
    font-size: 13px;
  }

  .edit-form .el-input__inner {
    height: 36px;
    font-size: 13px;
  }
}
</style>
